import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { FadeIn } from '../motion/FadeIn';
import { ArrowRight } from 'lucide-react';

export const CTASection = ({
  headline = "Every Declined Patient Is Revenue Waiting to Be Recovered",
  subheadline = "Your practice is already paying to get these patients through the door. Stop letting them walk out. Book a demo and see how practices are turning dead leads into accepted cases.",
  dark = true
}) => {
  return (
    <section className={`py-16 sm:py-20 ${
      dark
        ? 'bg-[hsl(var(--sss-navy))] text-white'
        : 'bg-[hsl(var(--accent))]'
    }`}>
      <div className="mx-auto max-w-[var(--grid-max)] px-4 sm:px-6 lg:px-8 text-center">
        <FadeIn>
          <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight ${
            dark ? 'text-white' : 'text-[hsl(var(--sss-navy))]'
          }`}>
            {headline}
          </h2>
          <p className={`mt-4 text-base md:text-lg max-w-2xl mx-auto ${
            dark ? 'text-white/80' : 'text-[hsl(var(--sss-ink))]/70'
          }`}>
            {subheadline}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/contact">
              <Button
                data-testid="cta-book-demo"
                className={`${
                  dark
                    ? 'bg-white text-[hsl(var(--sss-navy))] hover:bg-white/90'
                    : 'bg-[hsl(var(--sss-coral))] hover:bg-[hsl(var(--sss-coral-2))] text-white'
                } rounded-xl px-8 h-12 text-base font-medium shadow-md`}
              >
                Book a Demo
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <a href="https://approvemysmile.com/register/personal" target="_blank" rel="noopener noreferrer">
              <Button
                data-testid="cta-get-started"
                variant="outline"
                className={`${
                  dark
                    ? 'border-white/30 text-white hover:bg-white/10'
                    : 'border-[hsl(var(--sss-navy))] text-[hsl(var(--sss-navy))] hover:bg-[hsl(var(--sss-navy))] hover:text-white'
                } rounded-xl px-8 h-12 text-base font-medium`}
              >
                Get Started for $249/mo
              </Button>
            </a>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};
